import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import { Field, reduxForm } from 'redux-form';

import TextField from 'components/fields/TextField';

const styles = theme => ({
  root: {
    padding: '16px 24px',
    borderBottom: `1px solid ${theme.palette.primary.A400}`,
    [theme.breakpoints.down('xs')]: {
      padding: 8,
    },
  },
  form: {
    border: `1px solid ${theme.palette.primary.A100}`,
    borderRadius: 5,
  },
  inputRoot: {
    paddingLeft: 8,
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
  },
});

const PatientsDialogFilterForm = ({
  handleSubmit, classes,
}) => (
  <div className={classes.root}>
    <form
      className={classes.form}
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <Field
        id="Name or PRN"
        name="Name or PRN"
        component={TextField}
        type="search"
        placeholder="Search by Patient Name or PRN"
        fullWidth
        startAdornmentClearButton
        inputRootClassName={classes.inputRoot}
      />
    </form>
  </div>
);

PatientsDialogFilterForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    inputRoot: PropTypes.string.isRequired,
  }).isRequired,
};

export default reduxForm({
  onSubmit: () => {},
})(withStyles(styles)(PatientsDialogFilterForm));



// WEBPACK FOOTER //
// ./src/components/patient/PatientsDialog/PatientsDialogFilterForm.js